var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglephotos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#googlephotos_svg__clip0_5003_72696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 7.273c4.42 0 8 3.58 8 8V16H.727A.727.727 0 010 15.273c0-4.42 3.58-8 8-8z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.727 8c0 4.42-3.58 8-8 8H16V.727c0-.402.325-.727.727-.727 4.42 0 8 3.58 8 8z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 24.727c-4.42 0-8-3.58-8-8V16h15.273c.402 0 .727.325.727.727 0 4.42-3.58 8-8 8z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.273 24c0-4.42 3.58-8 8-8H16v15.273a.727.727 0 01-.727.727c-4.42 0-8-3.58-8-8z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "googlephotos_svg__clip0_5003_72696"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
export default SvgGooglephotos;